import { apiClient } from "../../../Utilities/apiClient";

interface SendNotificationPayload {
    title: string;
    body: string;
    userIds?: string[];
}

interface SendNotificationResponse {
    success: boolean;
    message: string;
    successCount: number;
    failureCount: number;
}

export const notificationService = {
    sendNotification: async (payload: SendNotificationPayload) => {
        return apiClient.post<SendNotificationResponse>(
            "/notifications/send",
            payload
        );
    },
};